import { default as _91propertyQName_93JB5xiqwt3FMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[base]Type/[propertyQName].vue?macro=true";
import { default as _91slug_93CE757dijnNMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[slug].vue?macro=true";
import { default as indexrJuS0DkKOFMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/index.vue?macro=true";
import { default as indexSkIjOzduiYMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/index.vue?macro=true";
import { default as index1zF3KqoTtbMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/index.vue?macro=true";
import { default as indexyJk2N65ZdJMeta } from "C:/git/niem/api/niem-toolbox/pages/browse/index.vue?macro=true";
import { default as indexq1zNnzr07BMeta } from "C:/git/niem/api/niem-toolbox/pages/index.vue?macro=true";
import { default as migrate5A7pBLx1LDMeta } from "C:/git/niem/api/niem-toolbox/pages/migrate.vue?macro=true";
import { default as release_45notesBLplfaR0YwMeta } from "C:/git/niem/api/niem-toolbox/pages/release-notes.vue?macro=true";
import { default as searchqL91Cm6YL9Meta } from "C:/git/niem/api/niem-toolbox/pages/search.vue?macro=true";
import { default as testVkqee8Zh9DMeta } from "C:/git/niem/api/niem-toolbox/pages/test.vue?macro=true";
import { default as transformlgBzmvvsfTMeta } from "C:/git/niem/api/niem-toolbox/pages/transform.vue?macro=true";
import { default as validateLZcPzziTk9Meta } from "C:/git/niem/api/niem-toolbox/pages/validate.vue?macro=true";
export default [
  {
    name: "browse-stewardKey-modelKey-versionNumber-baseType-propertyQName",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()/:base()Type/:propertyQName()",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[base]Type/[propertyQName].vue")
  },
  {
    name: "browse-stewardKey-modelKey-versionNumber-slug",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()/:slug()",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[slug].vue")
  },
  {
    name: "browse-stewardKey-modelKey-versionNumber",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/index.vue")
  },
  {
    name: "browse-stewardKey-modelKey",
    path: "/browse/:stewardKey()/:modelKey()",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/index.vue")
  },
  {
    name: "browse-stewardKey",
    path: "/browse/:stewardKey()",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/[stewardKey]/index.vue")
  },
  {
    name: "browse",
    path: "/browse",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/browse/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/index.vue")
  },
  {
    name: "migrate",
    path: "/migrate",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/migrate.vue")
  },
  {
    name: "release-notes",
    path: "/release-notes",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/release-notes.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/search.vue")
  },
  {
    name: "test",
    path: "/test",
    meta: testVkqee8Zh9DMeta || {},
    component: () => import("C:/git/niem/api/niem-toolbox/pages/test.vue")
  },
  {
    name: "transform",
    path: "/transform",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/transform.vue")
  },
  {
    name: "validate",
    path: "/validate",
    component: () => import("C:/git/niem/api/niem-toolbox/pages/validate.vue")
  }
]